<template>
	<vxe-modal v-model="modal" :title="title" width="1000" height="800" @show="show" show-footer destroy-on-close>
		<template #default>
			<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" height="auto" :ref="gridRef"></vxe-grid>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			title: {
				default: () => {
					return '明细'
				}
			}
		},
		data() {
			return {
				gridRef: Math.random(),
				sourcedata: [],
				modal: false,
				loading: false,
				list_formConfig: [],
				list_footerField: [{
					field: 'amount',
					fixed: 2
				}],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width: 80,
					}, {
						field: 'exchange_no',
						title: '售后单号',
					},
					{
						field: 'trade_no',
						title: '系统单号'
					},
					{
						field: 'originalStorage',
						title: '原发货仓',
					},
					{
						field: 'distribution',
						title: '配货员',
					},
					{
						field: 'packer',
						title: '打包员',
					}
				]
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.data
					})
				})

			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modalShow() {
				this.modal = true
			},
		},
		components: {

		}
	}
</script>